/* Colour-card swatches: native markup, one delegated handler for AJAX grids. */
(() => {
  if (window.cultumColourSwatchesLoaded) return;
  window.cultumColourSwatchesLoaded = true;
  const cache = new WeakMap();

  function activate(swatch) {
    const card = swatch.closest('product-block[data-colour-card]');
    if (!card) return;
    const grid = card.closest('.product-grid');
    const source = grid && grid.querySelector(`script[data-colour-states="${card.dataset.productId}"]`);
    if (!source) return;
    if (!cache.has(source)) cache.set(source, JSON.parse(source.textContent));
    const state = cache.get(source).find(item => item.colour === swatch.dataset.optionItem);
    if (!state) return;

    const imageSlot = card.querySelector('.image-label-wrap > div:first-child');
    if (imageSlot) imageSlot.innerHTML = state.image;
    card.querySelectorAll('a.product-link').forEach(link => { link.href = state.url; });
    card.querySelector('.product-block__colour').textContent = state.colour;
    card.querySelector('.product-price--block').innerHTML = state.price;
    const oldLabels = card.querySelector('.image-label-wrap .product-label-container');
    if (oldLabels) oldLabels.remove();
    card.querySelector('.image-label-wrap')?.insertAdjacentHTML('beforeend', state.labels);
    card.dataset.colourCard = state.colour;
    card.dataset.variantId = state.variant;
    card.dataset.colourAvailable = String(state.available);
    if (state.missingImage) card.dataset.colourImageMissing = 'true';
    else delete card.dataset.colourImageMissing;
    card.querySelectorAll('[data-colour-choice]').forEach(item => {
      item.setAttribute('aria-pressed', String(item.dataset.optionItem === state.colour));
    });
  }

  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-colour-choice]');
    if (!swatch) return;
    event.preventDefault();
    activate(swatch);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest('[data-colour-choice]');
    if (!swatch) return;
    event.preventDefault();
    activate(swatch);
  });
})();
